module.exports = __webpack_public_path__ + "img/code.c77d20ff.png";